import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import { SaleyardHome } from "containers/SaleyardHome";

import { getDashboardRoute, getSettingsRoute } from "lib/navigation";

import useSocketListener from "hooks/useSocketListener";

const RootRedirRoute = () => (
  <Switch>
    <Redirect
      exact
      path="/redir/settings__integrations/"
      to={getSettingsRoute("Integrations")}
    />
    {/* Redirect everything else just to root. */}
    <Redirect path="/redir/" to="/" />
  </Switch>
);

const Home = () => {
  useSocketListener();

  return (
    <Switch>
      <Route path="/redir/" component={RootRedirRoute} />
      <Route path="/saleyard/:saleyard" component={SaleyardHome} />
      <Route path="/saleyard/" component={SaleyardHome} />
      <Route path="/app/" component={SaleyardHome} />
      <Route path={getDashboardRoute()} component={SaleyardHome} />
      <Route path="/" component={SaleyardHome} />
    </Switch>
  );
};

export default Home;
